<template>
  <ds-tag
    v-if="kycStatus && kycStatus !== 'Not_checked'"
    :label="kycStatus"
    :version="kycTagVersion"
    :icon="kycIcon"
    icon-size="1rem"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'KycStatus',
  computed: {
    ...mapGetters(
      {
        kycStatus: 'qualification/kycStatus'
      }
    ),
    kycIcon () {
      switch (this.kycStatus) {
        case 'Approved':
          return 'checkmark';
        case 'Rejected':
          return 'close';
        default:
          return 'pending';
      }
    },
    kycTagVersion () {
      switch (this.kycStatus) {
        case 'Approved':
          return 'success';
        case 'Rejected':
          return 'error';
        default:
          return 'warning';
      }
    },
    kycColor () {
      switch (this.kycStatus) {
        case 'Approved':
          return 'var(--green-500)';
        case 'Rejected':
          return 'var(--red-500)';
        default:
          return 'var(--orange-500)';
      }
    }
  }
};
</script>
